import {
  INIT_SETUP,
  INIT_ROUTER,
  INIT_HTTP,
  INIT_THEME,
} from '@/constants';

export default {
  feedbackFrames: state => state.feedbackFrames,
  feedbackTracks: state => state.feedbackTracks,
  info: state => state.info,
  routed: state => state.initialize.some(stage => stage === INIT_ROUTER),
  themed: state => state.initialize.some(stage => stage === INIT_THEME),
  httped: state => state.initialize.some(stage => stage === INIT_HTTP),
  initialized: state => [INIT_SETUP, INIT_HTTP, INIT_ROUTER].every(stage => state.initialize.includes(stage)),
  language: state => state.language,
  // setting
  baseUrl: state => state.setting.base_url,
  baseUrlPath: state => state.setting.base_url_path,
  // branding
  theme: state => state.branding.theme,
  homeUrl: state => state.branding.home_url,
};
